import { z } from 'zod';

import { PolicyKind } from '@nucleus-commerce/api-client/admin';

/** `?kind=` preselects the kind on the create screen; the list links each missing kind with it. */
export const policyNewSearchSchema = z.object({
  kind: z.enum(PolicyKind).optional().catch(undefined),
});

export type PolicyNewSearch = z.infer<typeof policyNewSearchSchema>;
